import { useState } from "react";

import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import ActivePlanList from "./ActivePlanList";


const ActivePlan = () => {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)
  return (
    <div>
       <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
    <NavBar
      childrenPage={< ActivePlanList/>}
      menuId={5}
    />
  </DataContext.Provider>
    </div>
  )
}

export default ActivePlan
